<template>
    <AdmPanel>
        <h2 slot="header_title">指标管理</h2>
        <div slot="header_buttons" class="adm-buttons">
          <iv-button type="primary" v-rbac-allow="['carbonTarget','create']" @click="modal.create.shown=true">
            <iv-icon type="md-add" size="16" />
            <span>新增指标</span>
          </iv-button>
          <iv-button
            :loading="loader[TARGET+'export']"
            v-rbac-allow="['carbonTarget','export']"
            type="info"
            icon="md-download"
            ghost
            @click="exportExcel()"
          >导出</iv-button>
        </div>
        <FilterBar slot="tools" :value="conditions" :condition="options.filter_rules" @search="changeQuery">
          <iv-form-item>
          <iv-button
              :disabled="loader[TARGET]"
              type="info"
              @click="changeQuery()"
          >
              <iv-icon type="md-search" size="14" style="vertical-align:text-bottom"/> 查询
          </iv-button>
          </iv-form-item>
        </FilterBar>
        <div class="adm-panel__tools">
            <span style="width:6em;text-align: right;display: inline-block;">一级指标：</span>
            <iv-select
                v-model="conditions.firstTargetNum"
                filterable
                clearable
                style="width:120px"
                placeholder="一级指标"
                @on-change="changeQuery({ ...conditions,offset:0 });conditions.secondTargetNum = ''"
            >
                <iv-option v-for="(item, index) in options.firstTargets" :value="item.firstTargetNum" :key="index">{{ item.firstTargetName }}</iv-option>
            </iv-select>
        </div>
        <div class="adm-panel__tools">
            <span style="width:6em;text-align: right;display: inline-block;">二级指标：</span>
            <iv-select
                v-model="conditions.secondTargetNum"
                filterable
                clearable
                style="width:200px;"
                placeholder="二级指标"
                @on-change="changeQuery({ ...conditions,offset:0 });conditions.thirdTargetNum = ''"
            >
                <iv-option v-for="(item,key) in options.secondTargets" :value="item.secondTargetNum" :key="item.secondTargetNum + key">{{ item.secondTargetName }}</iv-option>
            </iv-select>
        </div>
        <div class="adm-panel__tools">
            <span style="width:6em;text-align: right;display: inline-block;">三级指标：</span>
            <iv-select
                v-model="conditions.thirdTargetNum"
                filterable
                clearable
                style="width:200px;"
                placeholder="三级指标"
                @on-change="changeQuery({ ...conditions,offset:0 })"
            >
                <iv-option v-for="(item,key) in options.thirdTargets" :value="item.thirdTargetNum" :key="item.thirdTargetNum + key">{{ item.thirdTargetName }}</iv-option>
            </iv-select>
        </div>
        <iv-table
                class="adm-table"
                :columns="columns"
                :loading="loader[TARGET]"
                :data="list.data">
        </iv-table>
        <template v-if="list.last_page > 1">
            <div slot="footer" class="pull-right">
                <iv-page
                        @on-change="pageChanged"
                        :current="list.current_page"
                        :page-size="10"
                        show-elevator
                        show-total
                        :total="list.total">
                </iv-page>
            </div>
        </template>

        <router-view></router-view>

        <TagsEditModel :item='editModel' @SaveKeyword="SaveKeyword" @shown-changed="editModel.show=$event"></TagsEditModel>

        <iv-modal
          v-model="modal.create.shown"
          :title="modal.create.title"
          :width="modal.create.width"
          closable
          @on-cancel="onModalClose('create')"
        >
          <iv-form @submit.native.prevent="">
            <iv-form-item label="搜索现有指标">
              <iv-input
                icon="ios-search"
                type="text"
                placeholder="输入指标名称进行搜索"
                v-model="modal.create.keyword"
                @on-keyup="searchTargetDE"
              />
            </iv-form-item>
            <ul class="adm-list" v-if="!!modal.create.keyword">
              <template v-for="item in modal.create.list.data">
                <li :key="item.id">
                  <div class="adm-split" style="padding:10px 7px">
                    <span>{{ item.secondTargetName }}({{ item.year }})</span>
                    <router-link
                      :to="{ name:'carbon_target_edit', params:{ 'thirdTargetNum':item.thirdTargetNum,'year':item.year,'industryId':item.industryId } }">
                      编辑</router-link>
                    <router-link :to="{ name:'carbon_target_edit', params:{ 'thirdTargetNum':item.thirdTargetNum,'industryId':item.industryId, 'action': 'baseEdit' } }">基于已有指标新增</router-link>
                  </div>
                </li>
              </template>
            </ul>
          </iv-form>
          <div slot="footer">
            <iv-button type="text" size="large" slot="footer" @click="onModalClose('create');modal.create.shown=false">取消</iv-button>
            <router-link slot="footer" :to="{ name:'carbon_target_create' }">
              <iv-button type="primary" size="large"><iv-icon type="md-add" size="16" />继续新增</iv-button>
            </router-link>
          </div>
        </iv-modal>
    </AdmPanel>
</template>
<script>
import debounce from "lodash.debounce";

import CarbonTargetModel from "@/models/CarbonTargetModel";
import CarbonCompanyModel from "@/models/CarbonCompanyModel";
import CarbonIndustryModel from "@/models/CarbonIndustryModel";

import ModelMixin from "@/mixins/Model.mixin";
import LoaderMixin from "@/mixins/Loader.mixin";
import contact from "@/utils/contact";
import { conditioner, unique , carbon_years, getProductYear, defaultVal, downloadByUrl  } from '@/utils/';
import FilterBar from "@/components/FilterBar_X2";
import TagsEditModel from '@/components/TagsEditModel'
import CheckedList from '@/components/CheckedList'
import { targetType, targetSource, classification } from "@/configs/options.conf";

const TARGET = CarbonTargetModel.ModelName; // remove '$'
const COMPANY = CarbonCompanyModel.ModelName;
const ModelName = TARGET;
const INDUSTRY = CarbonIndustryModel.ModelName

const _years = carbon_years().map(year=>({...year, title:year.name}))

const options = {
  targetType,
  targetSource,
  classification
}

const filter_rules = [
    {name: 'year', type: "Select", options: _years, title: '年份', default: "", placeholder: "年份"},
    {name: 'industryId', type: "Select", options: [], title: '行业', default: "", placeholder: "行业"},
    {name: 'targetSource', type: "Select", options: options.targetSource, title: '指标来源', default: "", clearable:true, placeholder: "指标来源", style: { width: "90px" }},
    {name: 'targetType', type: "Select", options: options.targetType, title: '指标类型', default: "", clearable:true, placeholder: "指标类型", style: { width: "90px" }},
    {name: 'classification', type: "Select", options: options.classification, title: '指标分类', default: "", clearable:true, placeholder: "指标分类", style: { width: "90px" }},
]

const _conditioner = conditioner(
      {//ui to url
        limit           : {type: Number, default: 10  },
        year            : {type: String , default: ""},
        industryId      : {type: Number , default: ""},
        targetSource    : {type: Number , default: ""},
        targetType      : {type: Number , default: ""},
        classification  : {type: Number , default: ""},
        firstTargetNum  : {type: String, default: ''  },
        secondTargetNum : {type: String, default: ''  },
        thirdTargetNum : {type: String, default: ''  },
        timestamp       : {type: val=>new Date().getTime(), default: ()=>new Date().getTime()}
      },
      {//url to ui
        limit           : {type: Number, default: 10},
        year            : {type: Number , default: ""},
        industryId      : {type: Number , default: ()=>''},
        targetSource    : {type: Number , default: ()=>''},
        targetType      : {type: Number , default: ()=>''},
        classification  : {type: Number , default: ()=>''},
        firstTargetNum  : {type: String, default: ''  },
        secondTargetNum : {type: String, default: ''  },
        thirdTargetNum : {type: String, default: '' }
      }
  )
function columns(vm){
  const allowEdit = vm.$rbac.allow(['carbonTarget', 'edit'])
  const allowDel = vm.$rbac.allow(['carbonTarget', 'delete'])
  const columns =  [
      {
          title: "序号",
          key: "number",
          align: "center",
          minWidth: 60,

      },
      {
          title: "一级指标",
          key: "firstTargetName",
          align: "center",
          minWidth: 120,
      },
      {
          title: "二级指标",
          key: "secondTargetName",
          align: "center",
          minWidth: 150,
      },
      {
          title: "三级指标",
          key: "thirdTargetName",
          align: "center",
          minWidth: 150,
      },
      {
          title: "行业",
          key: "industry",
          align: "center",
          minWidth: 90,
      },
        {
          title: "指标类型",
          key: "targetType",
          align: "center",
          minWidth: 90,
          render: (h, params)=>{
              let targetType = params.row.targetType
              const option = options.targetType.find(option=>option.id==targetType)
              if(!option) return <span>—</span>
              return <span>{ option.title }</span>
          }
      },
        {
          title: "指标分类",
          key: "classification",
          align: "center",
          minWidth: 90,
          render: (h, params)=>{
              let classification = params.row.classification
              const option = options.classification.find(option=> option.id == classification)
              if(!option) return <span>—</span>
              return <span>{ option.title }</span>
          }
      },
      {
          title: "单位",
          key: "targetUnit",
          align: "center",
          minWidth: 80,
          render: (h, params)=>{
              let targetUnit = params.row.targetUnit
              if(!targetUnit) return <span>—</span>
              return <span>{ targetUnit }</span>
          }
      },
      {
          title: "指标权重",
          key: "targetWeight",
          align: "center",
          minWidth: 90,
          render: (h, params)=>{
              const item = params.row;
              return  <iv-poptip placement="bottom-end" trigger="click" transfer>
                  <span>{ item.targetWeight }</span>
                  <a href="javascript:;" style="margin-left:.625em">
                      <iv-icon type="ios-information-circle" />
                  </a>
                  <div slot="content" class="adm-article text-left" style="max-width:200px; white-space: normal;word-break: break-all;">
                      <h5>指标说明</h5>
                      <div class="adm-info">
                      <p domPropsInnerHTML={ `${item.targetRuleExplain}`.replace(/\n/g, "<br>") || '无'}></p>
                  </div>
                  </div>
              </iv-poptip>
          }
      },
      {
          title: "关键词",
          key: "keyword",
          align: "center",
          minWidth: 300,
      },
  ]

  columns.push({
      title: "操作",
      align: "center",
      minWidth: allowEdit && allowDel ? 260 : 200,
      render(h, params){
          const item = params.row;

          const btnEditTags = <a href="javascript:;" onClick={ ()=>vm.edit(item) }>编辑关键词</a>
          const btnEdit = <router-link to={ ({ name: 'carbon_target_edit', params: { 'thirdTargetNum':item.thirdTargetNum,'year':item.year,'industryId':item.industryId }, query: { redirect:vm.$route.fullPath }  }) }>编辑</router-link>
          const btnDel = <a href="javascript:;" onClick={ ()=>vm.delete(item) }>删除</a>
          const logData = { type: "carbonTarget",thirdTargetNum: item.thirdTargetNum,'year':item.year,'industryId':item.industryId }

          return (
              <adm-link-group>
                  { allowEdit ? [btnEditTags,btnEdit]:'' }
                  { allowDel ? btnDel : '' }
                  <a href="javascript:;" onClick={ ()=>vm.$operationLog.show(logData) }>查看日志</a>
              </adm-link-group>
          );
      }
  })

  return columns
}
export default {
        name: "target",
        mixins:[
            LoaderMixin(TARGET,TARGET+'export',INDUSTRY),
            ModelMixin({
                contact,
                models:[
                    CarbonTargetModel,
                    CarbonCompanyModel,
                    CarbonIndustryModel,
                ]
            })
        ],
        data() {
            return {
                columns: columns(this),
                conditions: {
                    ..._conditioner.default()
                },
                ModelName,
                TARGET,
                COMPANY,
                INDUSTRY,
                list: {
                    data: [],
                    last_page:0,
                    current_page:1
                },
                options: {
                    ...options,
                    year: _years,
                    filter_rules
                },
                editModel:{
                    show        : false,
                    keyword     : ''
                },
                sources:{
                    FilterBar:{
                        secondTargetFake:'',
                        loading:false
                    }
                },
                industries:[],
                modal: {
                    create: {
                      shown: false,
                      title: "新增指标",
                      width: 600,
                      keyword: "",
                      list: {}
                    }
                }
            }
        },
        async mounted () {
            const { query, params } = this.$route
            this.conditions = _conditioner.serialize({...query,...params}) //处理成支持UI的格式
            this.options.year = carbon_years().map(year=>({...year,title:year.name}))
            this.conditions.year = this.conditions.year ? this.conditions.year : getProductYear()

            await this.refreshIndustry(this.conditions.year)
            this.conditions.industryId = defaultVal(this.conditions.industryId, this.industries[0].id)

            await this.refreshfirstTarget()
            await this.refreshsecondTarget({
              year: this.conditions.year,
              industryList: this.conditions.industryId ? JSON.stringify([this.conditions.industryId]) : undefined,
              firstTargetList: this.conditions.firstTargetNum ? JSON.stringify([this.conditions.firstTargetNum]) : undefined
            })
            await this.refreshthirdTarget({
              year: this.conditions.year,
              industryList: this.conditions.industryId ? JSON.stringify([this.conditions.industryId]) : undefined,
              firstTargetList: this.conditions.firstTargetNum ? JSON.stringify([this.conditions.firstTargetNum]) : undefined,
              secondTargetList: this.conditions.secondTargetNum ? JSON.stringify([this.conditions.secondTargetNum]) : undefined
            })
            this.refresh()
        },
        beforeRouteUpdate(to, from, next){
            this.$nextTick(async ()=>{
                const { query, params } = to
                this.conditions = {
                    ..._conditioner.default(),
                    ..._conditioner.serialize({...query,...params}) //处理成支持UI的格式
                }

                this.conditions.industryId = defaultVal(this.conditions.industryId, this.industries[0].id)
                await this.refreshsecondTarget({
                  year: this.conditions.year,
                  industryList: this.conditions.industryId ? JSON.stringify([this.conditions.industryId]) : undefined,
                  firstTargetList: this.conditions.firstTargetNum ? JSON.stringify([this.conditions.firstTargetNum]) : undefined
                })
                await this.refreshthirdTarget({
                  year: this.conditions.year,
                  industryList: this.conditions.industryId ? JSON.stringify([this.conditions.industryId]) : undefined,
                  firstTargetList: this.conditions.firstTargetNum ? JSON.stringify([this.conditions.firstTargetNum]) : undefined,
                  secondTargetList: this.conditions.secondTargetNum ? JSON.stringify([this.conditions.secondTargetNum]) : undefined
                })
                this.refresh()
            })
            next();
        },
        methods: {
            searchTargetDE: debounce(function(){ this.searchTarget() } ,250),
            async refresh(query=this.conditions){
                this.$$loading(TARGET);
                this.list = await this.$$fetch(ModelName, _conditioner.parse(query)); // 为啥一个简单的请求搞得这么复杂，徒徒增加阅读成本
                this.list.current_page = _conditioner.parse(query).offset ? _conditioner.parse(query).offset / _conditioner.parse(query).limit + 1 : 1
                this.list.last_page = this.list.total / _conditioner.parse(query).limit
                this.$$loaded(TARGET);
            },
            async refreshIndustry(year){
                const industry = await this.$$fetch(INDUSTRY, { year: year })
                const rule = this.options.filter_rules.find(item=>item.name=='industryId')
                rule.options = this.industries = industry.data.map(item=>({...item, title: item.industry }))
            },
            async refreshfirstTarget(params = this.$route.params){
                const firstTarget = await this.$$active(ModelName, 'firstTarget',params)
                if(firstTarget)  this.options.firstTargets = firstTarget.data
            },
            async refreshsecondTarget(params = this.$route.params){
                const secondTarget = await this.$$active(ModelName, 'secondTarget',params)
                if(secondTarget)  this.options.secondTargets = secondTarget.data
            },
            async refreshthirdTarget(params = this.$route.params){
                const thirdTarget = await this.$$active(ModelName, 'thirdTarget',params)
                if(thirdTarget) this.options.thirdTargets = thirdTarget.data
            },
            pageChanged(page){
                this.$router.push({ name: this.$route.name, query: { ...this.$route.query, offset: ( page - 1 ) *  _conditioner.parse(this.conditions).limit}, params: this.$route.params });
            },
            mergeQuery(query){
              return { ...this.conditions, ...query}
            },
            changeQuery(query=this.conditions, params = this.$route.params) {
                this.$router.push({
                    name  : this.$route.name,
                    query: {..._conditioner.parse(query), offset:0},
                    params: params
                });
            },
            edit(item){
                this.editModel = {
                    show : true,
                    ...item
                }
            },
            async SaveKeyword(item){
                const Keyword = await this.$$active(ModelName, 'SaveKeyword',item)
                this.refresh()
            },
            onFilterBarChanged({ conditions, fieldName, val }){
              this.changeQuery(this.mergeQuery({[fieldName]:val, offset:0}));
              if(['industryId','year'].indexOf(fieldName)>-1){
                this.refreshsecondTarget({year:conditions.year, industryList:JSON.stringify(conditions.industryId) })
                this.refreshthirdTarget({year:conditions.year, industryList:JSON.stringify(conditions.industryId) })
              }
            },
            async searchTarget(query={thirdTargetName: this.modal.create.keyword}){
              if(query.thirdTargetName.trim().length < 1) return
              this.modal.create.list = await this.$$active(TARGET, 'historyTarget', _conditioner.parse(query));
              this.modal.create.list.current_page = _conditioner.parse(query).offset ? _conditioner.parse(query).offset / _conditioner.parse(query).limit + 1 : 1;
              this.modal.create.list.last_page = this.modal.create.list.total / _conditioner.parse(query).limit;
            },
            onModalClose(type){
              if(type=='create'){
                this.modal.create.keyword = ""
                this.modal.create.list = { data:[] }
              }
            },
            delete(item){
              this.$$active(TARGET,'destroy',{ 'secondTargetNum': item.secondTargetNum,'year':item.year,'industryId':item.industryId })
              this.refresh({...this.conditions, offset:0})
            },
            async exportExcel(query = this.conditions) {
              // TODO:
              console.log("exportExcel...", this.conditions)
              const res = await this.$$active(TARGET, 'export', {type:this.model_type,..._conditioner.parse({...query,limit:999}) })
              if(!res.data.url) {
                this.$$info('后台未返回url，请重试')
                return
              }
              // 下载链接
              downloadByUrl(res.data.url)
            },
        },
        watch:{
          'conditions.year': {
            async handler (newVal, oldVal) {
              if (oldVal) {
                await this.refreshIndustry(newVal)
              }
            }
          },
        },
        components:{
            FilterBar,
            TagsEditModel,
            CheckedList
        }
    }
</script>
<style lang="postcss" scoped>
.inline-checkList {
  display: inline-block;
  margin-right: 20px;
}
.inline-checkList >>> span {
    display: inline-block !important;
}

.inline-checkList >>> div {
  display: inline-block !important;
}
</style>
